import { __require as r } from "./index.es87.js";
var e = r();
export {
  e as j
};
//# sourceMappingURL=index.es9.js.map
